/*
 * This file is part of the https://gitlab-intern.easd-support.de/easd/p26s26_energie_watchdog project.
 *
 * (c) 2026 EA Systems Dresden GmbH
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

/* App configuration */
export const SHOW_DEBUG = __SHOW_DEBUG__;
export const APP_NAME_1 = 'En';
export const APP_NAME_2 = 'Observe';
export const APP_NAME = `${APP_NAME_1}${APP_NAME_2}`;
export const APP_TITLES = {
    de: 'EnObserve - Wir machen Anomalien sichtbar.',
    en: 'EnObserve - We make anomalies visible.',
    es: 'EnObserve - Hacemos visibles las anomalías.',
} as const;

/* Plotly configuration */
export const PLOTLY_MIN_WIDTH = "1470px";                   // Without Scrollbalken if width > 1470px

/* Price traffic light configuration */
export const PRICE_TRAFFIC_LIGHT_URN = 'PUB.GRID.price_MWh';
export const PRICE_TRAFFIC_LIGHT_WARNING = 50;              // >= 50 €/MWh warning
export const PRICE_TRAFFIC_LIGHT_CRITICAL = 120;            // > 120 €/MWh critical

/* Status configuration */
export const GENERAL_STATUS_CRITICAL = 2;                   // >= 2 critical
export const GENERAL_STATUS_WARNING  = 1;                   // >= 1 warning

/* WL: Water-loss rate configuration */
export const WATER_LOSS_RATE_WARNING_LITRES_PER_HOUR = 4;   // >= 4 l/h warning
export const WATER_LOSS_RATE_CRITICAL_LITRES_PER_HOUR = 15; // >= 15 l/h critical

/* PV: ratio configuration */
export const PV_RATIO_IMPLAUSIBLE_LOWER = 0.0;              // < 0.0 implausible
export const PV_RATIO_CRITICAL = 0.9;                       // < 0.8 critical
export const PV_RATIO_WARNING  = 0.95;                      // < 0.95 warning
export const PV_RATIO_IMPLAUSIBLE_UPPER  = 1.1;             // > 1.1 implausible

/* HE: Weekend reduction configuration */
export const HE_WEEKEND_REDUCTION_WARNING  = 15;             // < 10%  warning
export const HE_WEEKEND_REDUCTION_CRITICAL = 5;              // < 5%  critical

/* HE: Cutoff temperature configuration */
export const HE_CUTOFF_TEMPERATURE_CRITICAL    = 30;        // >= 30°C critical
export const HE_CUTOFF_TEMPERATURE_WARNING     = 25;        // >= 25°C warning
export const HE_CUTOFF_TEMPERATURE_OK          = 10;        // >= 10°C ok

/* BL: Cost last configuration */
export const BL_COST_LAST_CRITICAL = 10;                    // >= 10 critical
export const BL_COST_LAST_WARNING  = 5;                     // >= 5 warning

/* BL: Cost last 14d configuration */
export const BL_COST_LAST_14D_CRITICAL = BL_COST_LAST_CRITICAL * 2;  // >= 20 critical
export const BL_COST_LAST_14D_WARNING  = BL_COST_LAST_WARNING  * 2;  // >= 10 warning

/* BL: Cost overall configuration */
export const BL_COST_OVERALL_CRITICAL = BL_COST_LAST_CRITICAL * 500; // >= 5000 critical
export const BL_COST_OVERALL_WARNING  = BL_COST_LAST_WARNING  * 500; // >= 2500 warning
export const BL_COST_OVERALL_PERIOD_YEARS = 4;
export const BL_COST_YEARLY_CRITICAL = BL_COST_OVERALL_CRITICAL / BL_COST_OVERALL_PERIOD_YEARS;
export const BL_COST_YEARLY_WARNING  = BL_COST_OVERALL_WARNING / BL_COST_OVERALL_PERIOD_YEARS;
export const BL_COST_MONTHLY_CRITICAL = BL_COST_YEARLY_CRITICAL / 12;
export const BL_COST_MONTHLY_WARNING  = BL_COST_YEARLY_WARNING / 12;
